<template>
  <div class="bottom-fixed-container">
    <el-button class="checkout-btn-disable" v-if="isAddOnOrder&&addOnOrderPriceDiff === 0">
      {{ $t("OrderPage[\"Confirm\"]") }}
    </el-button>
    <!-- 03/20/2025: disable checkout button if payment method is netPay because backend editOrder Api is not ready -->
    <el-button class="checkout-btn" v-else-if="editOrderSampleId || isAddOnOrder" @click="handleModifyOrderCheckout" :disabled="disableEditOrderCheckout">
      {{ checkoutBtnText }}
    </el-button>
    <div v-else>
      <el-button
        v-if="!isHideCheckout"
        id="order-summary-checkout-btn"
        class="checkout-btn"
        :disabled="(isDisableCheckout || !totalPrice) && selectedMerchList.length === 0"
        @click="$emit('handleCheckout')"
      >
        {{ $t("OrderPage[\"Checkout\"]") }}
      </el-button>    
    </div>
    <div v-if="showSecondaryActions" class="flex mt-2.5">
      <el-button 
        id="save-draft-btn"
        class="save-draft-btn" 
        @click="isOpenSaveDraftDialog = true"
      >
        {{ $t("OrderPage[\"Save Draft\"]") }}
      </el-button>
      <el-button class="cancel-btn" @click="clickCancel">{{ $t("OrderPage[\"Cancel\"]") }}</el-button>
    </div>
    <el-dialog
      v-if="showSecondaryActions && isOpenSaveDraftDialog"
      class="save-draft-dialog order-test"
      v-model="isOpenSaveDraftDialog"
      append-to-body
      :title="$t('OrderPage[\'Save as Draft\']')"
    >
      <p class="draft-order-title mb-1">{{ $t("OrderPage[\"Draft order title\"]") }}</p>
      <el-input
        v-model="draftNameChild"
        class="draft-order-name-input" 
        @change="updateDraftName"
      />
      <el-button 
        v-if="isOrderDraftNotExist"
        class="save-draft-btn-2 float-right mt-7"
        @click="isUpdateDraft=false; saveDraft()"
      >
        {{ $t("OrderPage[\"Save Draft\"]") }}
      </el-button>
      <div v-else class="float-right mt-7">
        <el-button 
          class="save-draft-btn-2 ml-3" 
          @click="isUpdateDraft=true; saveDraft()"
        >
          {{ $t("OrderPage[\"Update Draft\"]") }}
        </el-button>          
        <el-button 
          class="save-draft-btn-2 ml-3" 
          @click="isUpdateDraft=false; saveDraft()"
        >
          {{ $t("OrderPage[\"Create New Draft\"]") }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { isDisableCheckoutForRupa } from "../index.js";
import { clearSessionStorage } from "@/utils/va-order-test/index.js";
import { notify } from '@/utils/notify';
import { mapState, mapGetters } from "vuex";
export default {
  props: {
    isOrderDraftNotExist: {
      type: Boolean,
      default: true,
    },
    draftNameParent: {
      type: String,
      default: "",
    },
    totalPrice: {
      type: Number,
      default: 0.0,
    },
    showAccessories: {
      type: Boolean,
      default: true,
    },
    editOrderPriceDiff: {
      type:Number,
      default: 0
    },
    addOnOrderPriceDiff: {
      type: Number,
      default: 0
    } ,
    isDisableCheckout: {
      type: Boolean,
      default: false,
    },
    paymentMethod: {
      type: String,
      default: "",
    },
    showSecondaryActions: {
      type: Boolean,
      default: true,
    }
  },
  data() {
    return {
      isOpenSaveDraftDialog: false,
      draftNameChild: "",
      isUpdateDraft: false,
    }
  },

  emits:["updateDraftName","saveDraft","handleCheckout"],

  computed: {
    ...mapState("orderTest/order", ["editOrderSampleId"]),
    ...mapState("orderTest/user", ["userInfo"]),
    ...mapState("orderTest", ["isAddOnOrder"]),
    ...mapState("orderTest/orderDraft", ["orderDraft"]),
    ...mapGetters("orderTest/merchandise", ["selectedMerchList"]),

    // hide checkout for rupa clinic account 1007150 login
    // start from 02/01/2024
    isHideCheckout() {
      return isDisableCheckoutForRupa(this.userInfo)
    },

    checkoutBtnText() {
      if (["wellProz", "netPay"].includes(this.paymentMethod)) {
        return this.$t("OrderPage[\"Confirm\"]");
      }
      return this.editOrderPriceDiff > 0 || this.addOnOrderPriceDiff > 0 ? this.$t("OrderPage[\"Checkout\"]") : this.$t("OrderPage[\"Confirm\"]");
    },

    // disable checkout for edit order in following cases:
    // 1. payment method is netPay
    // 2. if order has coupon code, then disable in following cases:
    //    - customer id is 11432 as this customer has client promotion
    //    - it has sales promotion
    disableEditOrderCheckout() {
      if (this.paymentMethod === "netPay") {
        return true;
      }
      if (this.orderDraft.coupon) {
        return this.userInfo?.customer_id === 11432 || this.orderDraft.invoiceDiscount > 0;
      }
      return false;
    }
  },

  watch: {
    draftNameParent(newVal) {
      if (!this.draftNameChild && newVal) {
        this.draftNameChild = this.draftNameParent
      }
    }
  },

  mounted() {
    this.draftNameChild = this.draftNameParent
  },

  methods: {
    handleModifyOrderCheckout() {
      let orderType = null;
      if (this.isAddOnOrder) {
        orderType = "add";
      }
      if (this.editOrderSampleId) {
        orderType = "edit";
      }
      this.$emit("handleCheckout", orderType);
    },

    updateDraftName() {
      this.$emit("updateDraftName", this.draftNameChild)
    },

    saveDraft() {
      if (!this.draftNameChild){
        let message = this.$t("OrderPage[\"Please give a draft order title.\"]");
        notify({ type: 'error', message });
        return
      }
      this.$emit("saveDraft", this.isUpdateDraft);
      this.isOpenSaveDraftDialog = false;
      this.draftNameChild = this.draftNameParent;
    },

    clickCancel() {
      // remove stored info from sessionStorage
      clearSessionStorage();
      // initialize store
      this.$store.dispatch("orderTest/initializeStore");
       // set current draft id to empty, if any
      this.$store.dispatch("orderTest/orderDraft/setCurrentDraftId", "");
      // redirect back to patient search page
      this.$router.push("/ordertest");   
    }
  },
}
</script>


<style scoped>
.cancel-btn, .cancel-btn:hover {
  height: 40px;
  width: 182px;
  border-radius: 4px;
  border: 1px solid #C9CACD;
  background-color: #FFFFFF;
  font-size: 15px;
  color: #000000;
  font-size: 15px;
  font-weight: 500;
  letter-spacing: 0.43px;
}

.cancel-btn:active {
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
}

.save-draft-btn {
  height: 40px;
  width: 182px;
  border: 1px solid #20A8C3;
  box-sizing: border-box;
  border-radius: 4px;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  letter-spacing: 0.429px;
  color: #20A8C3;
}

.draft-order-title {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  letter-spacing: 0.4004px;
  color: #4A4A4A;
}

.save-draft-btn-2 {
  border: 1px solid #20A8C3;
  box-sizing: border-box;
  border-radius: 4px;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  letter-spacing: 0.429px;
  color: #20A8C3;
}

.checkout-btn, .checkout-btn:hover, .checkout-btn:focus {
  height: 42px;
  width: 100%;
  border-radius: 4px;
  background-color: #20A8C3;
  font-size: 15px;
  color: #ffffff;
  font-weight: 600;
  letter-spacing: 0.43px;
}

.checkout-btn:disabled {
  border-radius: 4px;
  border: 1px solid #E0E0E0;
  background: #E0E0E0;
  color: #525252;
  font-size: 15px;
  font-weight: 600;
  letter-spacing: 0.43px;
}

.checkout-btn:active {
  background: #0C96B1;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
}

.bottom-fixed-container {
  position: fixed;
  bottom: 26px;
  z-index: 1000 !important;
}

/* When inside order-summary-panel in PlaceOrderDialog, use absolute positioning */
.order-summary-panel .bottom-fixed-container {
  position: absolute !important;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 10;
}

.cart-sidebar .bottom-fixed-container {
  position: absolute !important;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 10;
}

.checkout-btn-disable {
  height: 42px;
  width: 100%;
  border-radius: 4px;
  background-color: #20A8C3;
  font-size: 15px;
  color: #ffffff;
  font-weight: 600;
  letter-spacing: 0.43px;
  pointer-events: none;
}
</style>